import { Injectable } from '@angular/core';
import { Router, TitleStrategy } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormControl, FormGroup} from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, delay } from 'rxjs/operators'; 
import * as moment from "moment";
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebapiService {
    //https://www.positronx.io/angular-httpclient-http-service/
    // Define API
    //apiURL = 'http://127.0.0.1:5000/';
    apiURL = environment.apiUrl;
    showLoader=false;
    newVideos:any;
    newMessage:any;

    // Http Options
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control':' no-cache, no-store, must-revalidate'
      }),
    };
    constructor(private http: HttpClient,private router: Router) {}

    setLoader(loading:boolean){
      this.showLoader=loading
    }

    slugify(string){
      return string.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
    }

    setNewVideos(vids:any){
      this.newVideos=vids
    }
    // HttpClient API get() method => Fetch Rules list
    getRules(): Observable<any> {
      return this.http
        .get(this.apiURL + 'video/allrules/')
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    allConditions(): Observable<any> {
      return this.http
        .get(this.apiURL + 'video/allconditions/')
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    /* stripe */

    getPlans(type=""): Observable<any> {
      if(type!="" && type!=null){
        return this.http
          .get(this.apiURL + 'stripe/getplans/'+type)
          .pipe(retry(1),
          delay(1000), catchError(this.handleError));
      }else{
        return new Observable
      }
    }

    /* stripe */

    // getAllLevelsOfRule(rule_id: Number): Observable<any> {
    //   return this.http
    //     .get(this.apiURL + 'video/allLevels/'+rule_id) 
    //     .pipe(retry(1),
    //     delay(1000), catchError(this.handleError));
    // }

    // getCategories(): Observable<any> {
    //   return this.http
    //     .get(this.apiURL + 'video/allCategories/')
    //     .pipe(retry(1),
    //     delay(1000), catchError(this.handleError));
    // }

    // getSkills(category_id:Number): Observable<any> {
    //   return this.http
    //     .get(this.apiURL + 'video/allSkills/'+category_id)
    //     .pipe(retry(1),
    //     delay(1000), catchError(this.handleError));
    // }

    // getAttributes(cat_id: Number): Observable<any> {
    //   return this.http
    //     .get(this.apiURL + 'video/getAttributes/'+cat_id)
    //     .pipe(retry(1),
    //     delay(1000), catchError(this.handleError));
    // }

    getSeriesFilters(): Observable<any> {
      return this.http
        .get(this.apiURL + 'seriesvideos/seriesfilters/',{})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }
    getSeries(params:any): Observable<any> {
      return this.http
        .get(this.apiURL + 'seriesvideos/series/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    getSeriesVideos(params:any): Observable<any> {
      return this.http
        .get(this.apiURL + 'seriesvideos/videos/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }
    
    addnotes(data:any) {
      return this.http
        .post(this.apiURL + 'seriesvideos/addnotes/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }
    
    addProgress(data:any) {
      return this.http
        .post(this.apiURL + 'seriesvideos/addprogress/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    getVideos(params:any): Observable<any> {
      return this.http
        .get(this.apiURL + 'video/allVideos/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }
    
    getFavouriteVideos(params:any): Observable<any> {
      return this.http
        .get(this.apiURL + 'video/favouriteVideos/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }
    
    getFavouriteSeriesVideos(params:any): Observable<any> {
      return this.http
        .get(this.apiURL + 'video/favouriteSeriesVideos/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    getUserData(): Observable<any> {
      const idToken = sessionStorage.getItem("id_token");
      if(idToken){
        return this.http
          .get(this.apiURL + 'user/info/')
          .pipe(retry(1),
          delay(1000), catchError(this.handleError));
      }else{
        return new Observable
      }
    }

    getCountries(): Observable<any> {
      return this.http
        .get(this.apiURL + 'user/countries/')
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    getHomerecentvideos(params:any={}): Observable<any> {
      return this.http
        .get(this.apiURL + 'video/homerecentvideos/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    getPlaylists(params:any={}){
      return this.http
      .get(this.apiURL + 'video/getPlaylists/',{params})
      .pipe(retry(1),
      delay(1000), catchError(this.handleError));
    }

    getInvitationData(params:any={}): Observable<any> {
      return this.http
        .get(this.apiURL + 'user/invitationData/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    removeConnection(params:any={}): Observable<any> {
      return this.http
        .get(this.apiURL + 'user/removeConnection/',{params})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    sendotp(data:any) {
      return this.http
        .post(this.apiURL + 'user/sendotp/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    resetpassword(data:any) {
      return this.http
        .post(this.apiURL + 'user/resetpassword/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    createPlaylist(data:any) {
      return this.http
        .post(this.apiURL + 'video/createPlaylist/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    

    deletePlaylist(data:any) {
      return this.http
        .post(this.apiURL + 'video/deletePlaylist/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }


    addToPlaylist(data:any) {
      return this.http
        .post(this.apiURL + 'video/addToPlaylist/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    shareToConnection(data:any) {
      return this.http
        .post(this.apiURL + 'video/shareToConnection/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    getPlaylistVideos(params:any={}) {
      return this.http
        .get(this.apiURL + 'video/getPlaylistVideos/', {params})
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    signup(data:any) {
      return this.http
        .post(this.apiURL + 'user/signup/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    exchangeCheckoutReturn(code:string) {
      return this.http
        .post(this.apiURL + 'user/exchangeCheckoutReturn/', {code})
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    cancelSubscription(data:any) {
      return this.http
        .post(this.apiURL + 'stripe/cancelSubscription/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    resumeSubscription(data:any) {
      return this.http
        .post(this.apiURL + 'stripe/resumeSubscription/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    pauseSubscription(data:any) {
      return this.http
        .post(this.apiURL + 'stripe/pauseSubscription/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    purchaseSubscription(data:any) {
      return this.http
        .post(this.apiURL + 'stripe/new-subscription/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    uploadProfileImage(data:any) {
      return this.http
        .post(this.apiURL + 'user/uploadProfileImage/', data,{headers: new HttpHeaders({
          'Access-Control-Allow-Origin':'*'
        })})
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    updateSubscription(data:any) {
      return this.http
        .post(this.apiURL + 'stripe/update-subscription/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    updateProfile(data:any) {
      return this.http
        .post(this.apiURL + 'user/updateprofile/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    // authentication functions
    login(email:string, password:string ): Observable<any> {
      return this.http
        .post(this.apiURL + 'user/login/', {email, password})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    setSession(authResult:any) {
      const expiresAt = moment().add(authResult.expires_in,'days');
      //console.log('expiry',expiresAt)
      sessionStorage.setItem('id_token', authResult.token);
      sessionStorage.setItem('userdata', JSON.stringify(authResult));
      sessionStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()) );
    }   

    legalityEmail(data:any) {
      return this.http
        .post(this.apiURL + 'user/legalityEmail/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    contactEmail(data:any) {
      return this.http
        .post(this.apiURL + 'user/contactEmail/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    skillSuggestion(data:any) {
      return this.http
        .post(this.apiURL + 'user/skillSuggestion/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    getallcards(){
      return this.http
        .get(this.apiURL + 'stripe/getallcards/')
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    frontendallplans(){
      return this.http
        .get(this.apiURL + 'stripe/frontendallplans/')
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    createpaymentmethod(data:any) {
      return this.http
        .post(this.apiURL + 'stripe/createpaymentmethod/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    addVideoToFavourite(video_id:any) {
      let data = {video_id:video_id}
      return this.http
        .post(this.apiURL + 'video/addtofav/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    inviteCoach(data:any) {
      return this.http
        .post(this.apiURL + 'user/inviteCoach/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    invitationSignup(data:any) {
      return this.http
        .post(this.apiURL + 'user/invitationSignup/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    redirectTo(uri:string){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.router.navigate([uri]));
    }

    logout() {
      //localStorage.removeItem("state");
      sessionStorage.removeItem("id_token");
      sessionStorage.removeItem("data");
      sessionStorage.removeItem("expires_at");
        this.setLoader(true)
        this.router.navigateByUrl('/');
        this.setLoader(false)
    }

    public isLoggedIn() {
        return moment().isBefore(this.getExpiration());
    }

    public userRole() {
      return sessionStorage.getItem("role") || '';
    }

    isLoggedOut() {
        return !this.isLoggedIn();
    }

    getExpiration() {
        const expiration = sessionStorage.getItem("expires_at") || '';
        const expiresAt = expiration ? JSON.parse(expiration) : null;
        let dateValue = null;
        return dateValue = expiresAt ? moment(expiresAt) : null;
    }  
    // end authentication functions

    // trigger validation
    validateAllFields(formGroup: FormGroup) {
      Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateAllFields(control);
        }
      });
    }
    // trigger validation

    // get errors
    getErrors (formGroup: FormGroup, errors: any = {}) {
      Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
          errors[field] = control.errors;
        } else if (control instanceof FormGroup) {
          errors[field] = this.getErrors(control);
        }
      });
      return errors;
    }
    //get errors

    showSmallDescription(text: any,length:number=160){
      var div = document.createElement("div");
      div.innerHTML = text;
      var text1 = div.textContent || div.innerText || "";
      div.remove()
      return text1.substring(0,length)
    }

    formatDate(date:any){
      return moment(date).format("YYYY-MM-DD");
    }

    // Error handling
    handleError(error: any) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      //window.alert(errorMessage);
      console.log(errorMessage)
      return throwError(() => {
        return errorMessage;
      });
    }
}

